import { useVehiclePhotosByKind } from 'Components/Gallery';

import { DamageCard } from '../ConditionAndDamageSection/Components/DamageCard';

import styles from './MobilizeInteriorDamageSection.module.scss';

export const MobilizeInteriorDamageSection: React.FC = () => {
	const images = useVehiclePhotosByKind(['damage_interior']);

	if (images.length === 0) {
		return <p>No interior damage reported</p>;
	}

	return (
		<div className={styles.grid} data-testid="mobilize-interior-damage-section">
			{images.map((image) => (
				<DamageCard key={image.id} image={image} showOverlay={false} />
			))}
		</div>
	);
};
